function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStar2I = function SvgStar2I(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.289 3.412a.82.82 0 0 1 .71-.412c.293 0 .565.158.712.412l2.712 4.781 5.422 1.08a.806.806 0 0 1 .44 1.341l-3.746 4.037.638 5.447a.8.8 0 0 1-.068.415.825.825 0 0 1-1.082.413l-5.028-2.284-5.025 2.284a.83.83 0 0 1-.822-.079.82.82 0 0 1-.329-.749l.638-5.447-3.746-4.037a.8.8 0 0 1-.175-.799.8.8 0 0 1 .233-.354.8.8 0 0 1 .382-.188l5.423-1.08z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStar2I);
export default ForwardRef;